import Empty from "@/components/empty.vue";
import Vue from 'vue';
import Component from 'vue-class-component';
import PreviewImg from '../components/preview-dialog.vue';
import PreviewVideo from '../components/preview-video.vue';
import ShootVideos from "../components/shoot-videos.vue";
import TakePhotosUsb from "../components/take-photos-usb.vue";
import TakePhotos from "../components/take-photos.vue";
import TakePhotos270 from "../components/take-photos-270.vue";
import TakePhotosNormal from "../components/take-photos-normal.vue";
import { GetExeImg, UploadFile } from "../request";
@Component({
  components: {
    Empty,
    TakePhotos,
    TakePhotos270,
    PreviewVideo,
    ShootVideos,
    TakePhotosUsb,
    PreviewImg,
    TakePhotosNormal
  },
})
export class sizhenMixin extends Vue {
  templateIndex: any = null
  c: any = {};
  cContent: any = {}; // 因为不能直接改动prop里面的数据，所以用Ccontent暂存下
  uid: any = ""; // 打开exe时生成的id
  ifShowTakePhotos: any = false;
  ifShowTakePhotos270: any = false;
  ifShowTakePhotosNormal: any = false;
  ifShowTakeUSBPhotos: any = false;
  ifShowShootVideos: any = false;
  ifShowPreview: any = false;
  ifShowPreviewVideo: any = false;
  previewUrl: any = '';
  get ifCompose() {
    return this.$store.state.ifCompose;
  }
  get patient() {
    return this.$store.state.patient;
  }
  preview(url: any) {
    // window.open(url);
    this.ifShowPreview = true;
    this.previewUrl = url
  }
  previewVideo(url: any) {
    this.ifShowPreviewVideo = true;
    this.previewUrl = url
  }
  closePreview() {
    this.ifShowPreview = false;
    this.ifShowPreviewVideo = false;
  }
  openTip() {
    this.$message.warning("请先点击编辑按钮进入编辑模式");
  }
  startFenxi() {
    this.$emit("save");
  }
  /**
   *  @description 删除一张图片或者视频
   */
  delOne(key: any, index: any) {
    this.c.value[key].splice(index, 1);
    this.$forceUpdate();
    this.$emit("update", this.c);
  }
  // 修改当前题目数据
  change() {
    this.$forceUpdate();
    this.$emit("update", this.c);
  }
  // 修改整个content数据
  changeContent() {
    console.log('根组件更新')
    this.$forceUpdate();
    this.$emit("updateContent", this.cContent);
  }
  changeTaiContent(e: any) {
    const index: any = e.findIndex((val: any) => {
      return val == '无苔'
    })
    if (index != -1) {
      this.cContent.report['舌象信息']['苔色'] = [[], []]
    }
    this.changeContent();
  }
  // 拍照功能
  /**
   * @description 打开拍照
   */
  startTakePhotos() {
    this.ifShowTakePhotos = true;
  }
  startTakePhotos270() {
    this.ifShowTakePhotos270 = true;
  }
  startTakePhotosNormal() {
    this.ifShowTakePhotosNormal = true;
  }
  takePhoneSure(val: any) {
    if (!this.c.value.imgs) {
      this.c.value.imgs = [];
    }
    this.c.value.imgs = val;
    this.$forceUpdate();
    this.$emit("update", this.c);
    this.ifShowTakePhotos = false;
  }
  takePhone270Sure(val: any) {
    if (!this.c.value.imgs) {
      this.c.value.imgs = [];
    }
    this.c.value.imgs = val;
    this.$forceUpdate();
    this.$emit("update", this.c);
    this.ifShowTakePhotos270 = false;
  }
  takePhoneNormalSure(val: any) {
    if (!this.c.value) {
      this.c.value = {}
    }
    if (!this.c.value.imgs) {
      this.c.value.imgs = [];
    }
    this.c.value.imgs = val;
    this.$forceUpdate();
    this.$emit("update", this.c);
    this.ifShowTakePhotosNormal = false;
  }

  // USB 拍摄照片
  /**
   * @description 打开USB拍照
   */
  startTakeUSBPhotos() {
    this.ifShowTakeUSBPhotos = true;
  }
  takeUSBPhoneSure(val: any) {
    this.c.value.imgs = val;
    this.$forceUpdate();
    this.$emit("update", this.c);
    this.ifShowTakeUSBPhotos = false;
  }


  // USB 拍摄视频
  /**
 * @description 打开USB拍视频
 */
  startShootVideos() {
    this.ifShowShootVideos = true;
  }
  shootVideosSure(val: any) {
    if (!this.c.value.videos) {
      this.c.value.videos = [];
    }
    this.c.value.videos.push(val);
    this.$forceUpdate();
    this.$emit("update", this.c);
    this.ifShowShootVideos = false;
  }


  // 调取舌象设备拍摄,这里拍摄完成后会直接调取保存接口
  GoSheDevices() {
    if (!this.ifCompose) {
      this.$message.warning("请先点击编辑按钮");
      return;
    }
    this.uid = Date.now() + "_" + this.patient.id;
    window.electronMyAPI.launchExe("tongue", this.uid);
    // 弹出中间弹框
    this.$confirm("舌象照片采集完成!", "舌象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      confirmButtonText: "查看报告",
      showCancelButton: false,
    }).then(() => {
      // 先获取图片填充到value，然后保存content
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          uid: this.uid,
          name: "tongue",
        },
      };
      GetExeImg(this, params, loading).then((res: any) => {
        loading.close();
        if (res.code == 2000) {
          let d: any = JSON.parse(JSON.stringify(this.c));
          d.value.imgs = [res.data];
          this.$forceUpdate();
          this.$emit("update", d);
          // 保存
          this.$emit("save");
        } else {
          this.$confirm("对不起，报告查看失败，请重新拍摄！", "查看报告", {
            customClass: "commonConfirm",
            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
            confirmButtonText: "重新拍摄",
            cancelButtonText: "返回",
          })
            .then(() => {
              this.GoSheDevices();
            })
            .catch(() => {
              this.$store.commit("updateIfCompose", false);
              if (this.$store.state.defaultPage) {
                this.$router.push(this.$store.state.defaultPage);
              } else {
                this.$router.push("/main/manage/folder");
              }
            });
        }
      });
    });
  }


  // 调取面象设备拍摄,这里拍摄完成后会直接调取保存接口
  GoMianDevices() {
    if (!this.ifCompose) {
      this.$message.warning("请先点击编辑按钮");
      return;
    }
    this.uid = Date.now() + "_" + this.patient.id;
    window.electronMyAPI.launchExe("face", this.uid);
    // 弹出中间弹框
    this.$confirm("面象照片采集完成!", "面象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      confirmButtonText: "查看报告",
      showCancelButton: false,
    }).then(() => {
      // 先获取图片填充到value，然后保存content
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          uid: this.uid,
          name: "face",
        },
      };
      GetExeImg(this, params, loading).then((res: any) => {
        loading.close();
        if (res.code == 2000) {
          // 修改value
          let d: any = JSON.parse(JSON.stringify(this.c));
          d.value.imgs = [res.data];
          this.$forceUpdate();
          this.$emit("update", d);
          // 保存
          this.$emit("save");
        } else {
          this.$confirm("对不起，报告查看失败，请重新拍摄！", "查看报告", {
            customClass: "commonConfirm",
            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
            confirmButtonText: "重新拍摄",
            cancelButtonText: "返回",
          })
            .then(() => {
              this.GoMianDevices();
            })
            .catch(() => {
              this.$store.commit("updateIfCompose", false);
              if (this.$store.state.defaultPage) {
                this.$router.push(this.$store.state.defaultPage);
              } else {
                this.$router.push("/main/manage/folder");
              }
            });
        }
      });
    });
  }


  // 调取脉象设备拍摄,这里拍摄完成后会直接调取保存接口
  GoMaiDevices() {
    if (!this.ifCompose) {
      this.$message.warning("请先点击编辑按钮");
      return;
    }
    this.uid = Date.now() + "_" + this.patient.id;
    window.electronMyAPI.launchExe("pulse", this.uid);
    // 弹出中间弹框
    this.$confirm("脉象数据", "脉象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      confirmButtonText: "查看报告",
      showCancelButton: false,
    }).then(async () => {
      // const data = {
      //   imgs: {
      //     左脉: [
      //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1745220673.239407.Seg-264-1-2.jpg",
      //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1745220672.857759.Best-264-1-2.jpg",
      //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1745220673.070928.PH-264-1-2.jpg",
      //     ],
      //     右脉: [],
      //   },
      //   report: {
      //     左手分段压脉图:
      //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1745220673.239407.Seg-264-1-2.jpg",
      //     左手最佳压力脉图:
      //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1745220672.857759.Best-264-1-2.jpg",
      //     "左手脉象p-h趋势图":
      //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1745220673.070928.PH-264-1-2.jpg",
      //     左手连续脉图: "",
      //     左手脉象信息输出: {
      //       流利度: "",
      //       紧张度: "",
      //       脉位: "浮",
      //       脉力: "有力",
      //       脉名: "脉代",
      //       脉率: "慢(20times/min)",
      //       脉节律: "不齐",
      //     },
      //     左手最佳脉象图参数: {
      //       A: 0.0,
      //       Ad: 71.5737,
      //       As: 117.378,
      //       h1: 44.9991,
      //       h2: 35.7308,
      //       h3: 37.2658,
      //       "h3/h1": 0.83,
      //       h4: 14.3275,
      //       "h4/h1": 0.32,
      //       h5: 13.1006,
      //       "h5/h1": 0.29,
      //       t: 0.39175,
      //       t1: 0.0715,
      //       "t1/t": 0.18,
      //       t2: 0.10825,
      //       t3: 0.12275,
      //       t4: 0.1995,
      //       t5: 0.19225,
      //       "t5/t4": 0.96,
      //       w1: 0.08225,
      //       "w1/t": 0.21,
      //       w2: 0.0165,
      //       "w2/t": 0.04,
      //     },
      //     右手分段压脉图: "",
      //     右手最佳压力脉图: "",
      //     "右手脉象p-h趋势图": "",
      //     右手连续脉图: "",
      //     右手最佳脉象图参数: {},
      //     右手脉象信息输出: {},
      //   },
      // };
      // // 修改value
      // this.cContent.data[this.templateIndex].value = data.imgs;
      // // 修改report
      // this.cContent.report = data.report;
      // this.$forceUpdate();
      // console.log(this.cContent)
      // this.$emit("updateContent", this.cContent);
      // // 保存
      // this.$emit("save");
      // return;
      // 上传脉
      const res = await window.electronMyAPI.uploadPulse(this.uid);

      // 先获取图片填充到value，然后保存content
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          uid: res,
          name: "pulse",
        },
      };
      GetExeImg(this, params, loading).then((res: any) => {
        loading.close();
        if (res.code == 2000) {
          // 修改value
          this.cContent.data[this.templateIndex].value = res.data.imgs;
          // 修改report
          this.cContent.report = res.data.report;
          this.changeContent();
          // 保存
          this.$emit("save");
        } else {
          this.$confirm("对不起，报告查看失败，请重新采集！", "查看报告", {
            customClass: "commonConfirm",
            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
            confirmButtonText: "重新采集",
            cancelButtonText: "返回",
          })
            .then(() => {
              this.GoMaiDevices();
            })
            .catch(() => {
              this.$store.commit("updateIfCompose", false);
              if (this.$store.state.defaultPage) {
                this.$router.push(this.$store.state.defaultPage);
              } else {
                this.$router.push("/main/manage/folder");
              }
            });
        }
      });
    });
  }



  // 上传视频
  /**
   * @description 上传视频
   */
  uploadVideo(d: any) {
    if (!this.c.value.videos) {
      this.c.value.videos = [];
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    UploadFile(this, form, loading).then((data: any) => {
      this.c.value.videos.push(data.data);
      this.$forceUpdate();
      this.$emit("update", this.c);
    });
  }


  /**
   * @description 上传图片
   */
  upload(d: any) {
    if (!this.c.value.imgs) {
      this.c.value.imgs = [];
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    UploadFile(this, form, loading).then((data: any) => {
      this.c.value.imgs.push(data.data);
      this.$forceUpdate();
      this.$emit("update", this.c);
    });
  }
}